var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReviewCard = function SvgReviewCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 178,
    viewBox: "0 0 315 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.66 0H22.13C9.91 0 0 9.91 0 22.13V137.23C0 149.45 9.91 159.36 22.13 159.36H126.2L144.84 178L163.48 159.36H292.66C304.88 159.36 314.79 149.45 314.79 137.23V22.14C314.8 9.91 304.89 0 292.66 0Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5705 67.638C71.3383 62.6824 76.8606 49.1255 71.905 37.3577C66.9495 25.59 53.3925 20.0676 41.6248 25.0232C29.857 29.9788 24.3347 43.5357 29.2903 55.3035C34.2458 67.0712 47.8028 72.5936 59.5705 67.638Z",
    fill: "#AFD5F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7798 25.332L103.02 38.052L116.43 37.952L105.64 45.922L109.89 58.642L98.9798 50.842L88.1898 58.812L92.2298 46.022L81.3198 38.222L94.7298 38.122L98.7798 25.332Z",
    fill: "#FAAF3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 25.332L145.74 38.052L159.15 37.952L148.36 45.922L152.61 58.642L141.7 50.842L130.91 58.812L134.95 46.022L124.04 38.222L137.45 38.122L141.5 25.332Z",
    fill: "#FAAF3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.22 25.332L188.46 38.052L201.87 37.952L191.08 45.922L195.33 58.642L184.41 50.842L173.63 58.812L177.67 46.022L166.76 38.222L180.17 38.122L184.22 25.332Z",
    fill: "#FAAF3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.94 25.332L231.18 38.052L244.59 37.952L233.8 45.922L238.05 58.642L227.13 50.842L216.34 58.812L220.39 46.022L209.48 38.222L222.89 38.122L226.94 25.332Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M269.66 25.332L273.9 38.052L287.31 37.952L276.52 45.922L280.77 58.642L269.85 50.842L259.06 58.812L263.11 46.022L252.2 38.222L265.61 38.122L269.66 25.332Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.67 79.7695H26.25V85.2295H46.67V79.7695Z",
    fill: "#AFD5F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.32 79.7695H51.71V85.2295H82.32V79.7695Z",
    fill: "#AFD5F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.29 95.9688H26.25V101.429H70.29V95.9688Z",
    fill: "#DFECFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.28 95.9688H88.2402V101.429H191.28V95.9688Z",
    fill: "#DFECFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M288.54 95.9688H209.23V101.429H288.54V95.9688Z",
    fill: "#DFECFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.71 113.34H26.25V118.8H124.71V113.34Z",
    fill: "#DFECFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M288.54 113.34H239.33V118.8H288.54V113.34Z",
    fill: "#DFECFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M227.76 113.34H141.5V118.8H227.76V113.34Z",
    fill: "#DFECFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.91 130.707H26.25V136.167H151.91V130.707Z",
    fill: "#DFECFC"
  })));
};
export default SvgReviewCard;